// Useful reference: https://codeburst.io/vuex-and-typescript-3427ba78cfa8
import Vue from 'vue';
import Vuex, { StoreOptions } from 'vuex';
import { RootState } from './types';

/** Import Modules */
import {auth} from './modules/auth';
import {profiles} from './modules/profiles';
import {general} from './modules/general';
import {options} from './modules/options';
import {selections} from './modules/selections';
import {attributeCounts} from './modules/attributeCounts';
import {results} from './modules/results';
import {buckets} from './modules/buckets';
import companies from './modules/companies';
Vue.use(Vuex);

const store: StoreOptions<RootState> = {
  modules: {
    auth,
    profiles,
    general,
    options,
    selections,
    attributeCounts,
    results,
    buckets,
    companies
  }
};

export default new Vuex.Store<RootState>(store);
